<template>
  <div _flex="~">
    <tree-item
      v-for="item in data"
      :key="item.id"
      :item="item"
    ></tree-item>
  </div>
</template>

<script>
import TreeItem from './treeItem.vue';

export default {
  name: 'TreeView',
  components: {
    TreeItem
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
</style>
